/**
 * Gets parent URL of a "match" react-router URL
 *
 * @format
 * @param url
 */

export const parentUrl = (url) => {
  if (url === '/') return '';
  const split = url.split('/').filter(Boolean);
  if (split.length <= 1) {
    return '';
  }
  return `/${split.join('/').replace(/\/(.*?)$/i, '')}`;
};

export const getQueryParams = (url) =>
  new Proxy(new URLSearchParams(url), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

const CARTES_GOUV_BASE_URL = 'https://cartes.gouv.fr/explorer-les-cartes/';
const ORTHOPHOTO_LAYER =
  'ORTHOIMAGERY.ORTHOPHOTOS$GEOPORTAIL:OGC:WMTS(1;1;1;0)';
const CADASTRAL_LAYER =
  'CADASTRALPARCELS.PARCELLAIRE_EXPRESS$GEOPORTAIL:OGC:WMTS(2;1;1;0)';

export const getCartesGouvUrl = (
  longitude,
  latitude,
  { withCadastral = false } = {},
) => {
  const layers = withCadastral
    ? `${CADASTRAL_LAYER},${ORTHOPHOTO_LAYER}`
    : ORTHOPHOTO_LAYER;

  return `${CARTES_GOUV_BASE_URL}?c=${longitude},${latitude}&l=${layers}&permalink=yes&z=19`;
};

export default null;
